import { AboutUsPageTranslationsUk } from 'pages/AboutUsPage/translations/uk';
import { NotFoundPageTranslationsUk } from 'pages/NotFoundPage/translations/uk';
import { UserPageTranslationsUk } from 'pages/UserPage/translations/uk';

export const PagesTranslationsUk = {
  notFoundPage: NotFoundPageTranslationsUk,
  aboutUsPage: AboutUsPageTranslationsUk,

  userPage: UserPageTranslationsUk, // =>

};
